import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      details: error.toString()
    });
  }


  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary p-4 bg-red-50 border border-red-200 rounded-lg">
          <h2 className="text-red-600 font-bold text-lg mb-2">Something went wrong.</h2>
          <p className="text-red-500 text-sm">
            Please try refreshing the page or contact support.
          </p>
        </div>
      );
    }


    return this.props.children;
  }
}

export default ErrorBoundary;
